export default {
  index: [
    {
      path: '/qccplan',
      component: resolve => require(['./qccplanIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/qccplan/_router.js